import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Tabs, Tab } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function MasterDataScreen() {
  const [tab, setTab] = useState(0);

  return (
    <ScreenFrame
      title="Master data"
      actions={<Button component={Link} to="/prototype/dashboard" variant="outlined" size="small">Dashboard</Button>}
    >
      <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label="Suppliers" />
        <Tab label="Raw materials" />
        <Tab label="Retailers" />
      </Tabs>
      <Typography color="text.secondary">
        {tab === 0 && 'Suppliers list. Add / Edit / Delete (with confirm).'}
        {tab === 1 && 'Raw materials list.'}
        {tab === 2 && 'Retailers list.'}
      </Typography>
    </ScreenFrame>
  );
}
